var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M40.25,80.5A40.25,40.25,0,1,1,80.5,40.25,40.3,40.3,0,0,1,40.25,80.5Zm0-73.4A33.15,33.15,0,1,0,73.4,40.25,33.19,33.19,0,0,0,40.25,7.1Z","fill":"#2a2d58","key":1}),React.createElement("path",{"d":"M56.09,36.7H43.8V24.41a3.55,3.55,0,1,0-7.1,0V36.7H24.41a3.55,3.55,0,0,0,0,7.1H36.7V56.09a3.55,3.55,0,0,0,7.1,0V43.8H56.09a3.55,3.55,0,0,0,0-7.1Z","fill":"#f1b860","key":2})]);
}

Plus.defaultProps = {"viewBox":"0 0 80.5 80.5"};

module.exports = Plus;

Plus.default = Plus;
